import Vue from "vue";
// import store from "@/store";
// import { get_storage } from "@/utils/util";

import defaultAvatar from "@/assets/default-avatar.png";

const $P = {
    $emit: (...args) => {
        eventCenter.$emit(...args);
    },
    $on: (...args) => eventCenter.$on(...args),
    $once: (...args) => eventCenter.$once(...args),
    $off: (...args) => eventCenter.$off(...args)
};

const eventCenter = new Vue();
Vue.prototype.$P = $P;

//  域名
$P.baseUrl = process.env.VUE_APP_BASE_URL;

//  下载图标
$P.downloadIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" /></svg>`;

//  默认头像
$P.defaultAvatar = defaultAvatar;

//  查找接口
$P.schemaType = "basicData";

$P.returnIndex = _self => {
    if (
        _self.$route.name === "favorites" ||
        _self.$route.name === "favorites-details" ||
        _self.$route.name === "instructions"
    ) {
        _self.$router.push("/");
    }
};
